import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_3213112126 from "../../../../../packages/component/src/components/config-provider/demo/demo1.js?loadDemo";
import legacyImportDemo_1904643677 from "../../../../../packages/component/src/components/config-provider/demo/demo2.js?loadDemo";
import legacyImportDemo_3419533052 from "../../../../../packages/component/src/components/config-provider/demo/demo3.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_3213112126,
  legacyImportDemo_1904643677,
  legacyImportDemo_3419533052,
  React
};